import { State } from '../reducers/types'
import { Partner, PartnerPublicInfo } from 'src/interfaces/partner'
import { PartnerStatus } from 'src/constants/partner'

export const getPartnerPublicInfo = (state: State): PartnerPublicInfo | null =>
  state.partner.partnerPublic

export const getPartner = (state: State): Partner | null => state.partner.partner

export const getIsPartnerDeactivated = (state: State): boolean => {
  return state.partner.partner?.status === PartnerStatus.Deleted
}

export const getIsPartnerFetchPending = (state: State): boolean => {
  return state.partner.partnerFetchStatus === 'pending'
}

export const getIsPartnerAccessRestricted = (state: State): boolean => {
  if (state.partner.partnerFetchStatus !== 'success') {
    return true
  }

  return state.partner.partner?.status === PartnerStatus.Deleted
}
